import { CommonModule, NgFor } from '@angular/common';
import { Component, effect, inject, input, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFacebook, faLinkedin, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { RouterModule } from '@angular/router';
import { AbsoluteMediaUriService } from '../../../services/absolute-media-uri.service';

@Component({
  selector: 'app-footer',
  imports: [NgFor, CommonModule, FontAwesomeModule, RouterModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit {
  protected readonly absoluteMediaUriService = inject(AbsoluteMediaUriService);
  protected icons = {
    faFacebook: faFacebook,
    faXTwitter: faXTwitter,
    faLinkedin: faLinkedin
  }

  public showSocial = input(true);

  linksRight: { label: string; url: string }[] = [];
  linksLeft: { label: string; url: string }[] = [
    { label: 'Privacy Policy', url: 'https://www.frontstream.com/privacy-policy' },
    { label: 'Terms of Use', url: this.absoluteMediaUriService.getAbsoluteMediaUri('/docs/eula_buyer.pdf') },
    { label: 'Cookie Policy', url: 'https://www.frontstream.com/cookie-policy' },
    { label: 'Accessibility', url: 'https://www.frontstream.com/accessibility-statement' },
  ];
  copyright = {
    year: '',
    orgName: '',
    company: '',
    companyUrl: '',
    message: ''
  };

  contactUrl!: string;

  private readonly apiService = inject(ApiService);

  constructor() {

    effect(() => {
      const homeSignal = this.apiService.homePageSignal();
      if (homeSignal != null) {
        const id = homeSignal.auctionId;
        const orgName = homeSignal.orgName;
        this.setUpLinks(id, orgName);
      }
    });
  }

  ngOnInit() {
    const homeSignal = this.apiService.homePageSignal();
    if (homeSignal != null) {
      const id = homeSignal.auctionId;
      const orgName = homeSignal.orgName;
      this.setUpLinks(id, orgName);
    }
  }

  private setUpLinks = (id: number, orgName: string) => {
    this.contactUrl = this.absoluteMediaUriService.getAbsoluteMediaUri('/auction/communicate/contactus.action') + `?auctionId=${id}`
    const currentYear = new Date().getFullYear();

    this.copyright = {
      year: `2003-${currentYear}`,
      orgName: orgName,
      company: 'BiddingForGood Inc.',
      companyUrl: this.absoluteMediaUriService.getAbsoluteMediaUri(''),
      message: 'All Rights Reserved. Designated trademarks and brands are the property of their respective owners.',
    };

    this.linksRight = [
      { label: 'Contact Us', url: `/contact-us/${id}` },
      { label: 'Help', url: 'https://frontstream.zendesk.com/hc/en-us/sections/115001633423-Bidder-FAQ' },
      { label: 'Run an Online Fundraiser', url: 'https://www.frontstream.com/biddingforgood/auctions?utm_source=BFG&utm_campaign=bfg-request-a-demo&utm_medium=referral&utm_content=auction-footer&_gl=1*10hdtfa*_ga*MzQ1MzMwMDQ0LjE3MjEzMjQ1NjQ.*_ga_ZLD1L6T1GE*MTc0NDc0MTQzNi4xMzEuMS4xNzQ0ODMxNzI4LjAuMC4w' },
    ];
  }
}
